import { api } from '../lib/apiClient';
import type { SaisieDroitImage } from '../lib/droitImage';

/**
 * Applique la saisie du droit a l'image (2026-10-13) : un seul appel,
 * idempotent, qui pose, remplace ou retire l'autorisation de l'annee —
 * tout a « non renseigne », sans date ni commentaire, le serveur retire
 * la ligne. Rien ne part si la saisie n'a pas change ; comme pour la
 * cotisation, la saisie initiale vient de la FICHE, pas d'un chargement
 * propre au formulaire.
 */
export async function enregistrerDroitImage(
  personneId: string,
  saisie: SaisieDroitImage,
  initiale: SaisieDroitImage,
  anneeId: string | null,
): Promise<void> {
  if (!anneeId || JSON.stringify(saisie) === JSON.stringify(initiale)) return;

  await api.put(`/api/personnes/${personneId}/droit-image`, {
    anneeId,
    etat: saisie.etat || null,
    dateSignature: saisie.dateSignature || null,
    commentaire: saisie.commentaire || null,
  });
}
